// extracted by mini-css-extract-plugin
module.exports = {"container":"I9SNdh","iconWrapper":"fevdem","icon":"OuMtVq","thumbBackground":"ZIBUJh","text":"UKD0Oa","hasVoted":"c2ltbyZ","voted":"c50etnB"};